import {
  EfficientListLoaderBase,
  IProps,
  MaybeFake,
} from "@faire/deprecated-retailer-visitor-shared/components/EfficientListLoader/EfficientListLoader";
import isUndefined from "lodash/isUndefined";
import React from "react";

/**
 * `EfficientListLoaderV2` is the same as `EfficientListLoader`, but
 * prevents re-rendering when the `hashkey` does not change.
 */
export const SearchPageEfficientListLoader = React.memo(
  <T, MaybeFakeT extends MaybeFake<T>, K>(props: IProps<MaybeFakeT | T, K>) => {
    return <EfficientListLoaderBase key={props.hashKey} {...props} />;
  },
  (prevProps, nextProps) => {
    if (
      prevProps.hashKey !== nextProps.hashKey ||
      prevProps.batchSize !== nextProps.batchSize
    ) {
      return false;
    }
    /**
     * Handles the case when `hashKey` is updated before `data`, resulting in the `hashKey`
     * remaining the same while `data` changes from `undefined` to not `undefined`.
     */
    if (
      prevProps.data.every(isUndefined) !== nextProps.data.every(isUndefined)
    ) {
      return false;
    }
    return true;
  }
) as typeof EfficientListLoaderBase;
